<template>
  <div>
    <v-card-title class="justify-center text-h5">
      {{ $t("salesPartnershipUsersLabel") }}
    </v-card-title>
    <SalesPartnershipUsersTable v-if="init" :company-id="parseInt(companyId)"/>
  </div>
</template>

<script>
import SalesPartnershipUsersTable from "@/views/spadmin/SalesPartnershipUsersTable";
import {mapGetters} from "vuex";
export default {
  name: "SalesPartnershipUsers",
  components: {SalesPartnershipUsersTable},
  data: () => ({
    init: false,
    companyId: 0
  }),
  computed: {
    ...mapGetters(['getCurrentUser'])
  },
  mounted() {
    this.companyId = this.getCurrentUser.companyId
    this.init = true
  }
}
</script>

<style scoped>

</style>